import { useState, useEffect } from 'react';
import { LeadWithFunnel } from '../types';

export interface UseCrmLeadsOptions {
  funnelId?: number;
  stepId?: string;
  view?: 'kanban' | 'list';
}

export interface UseCrmLeadsReturn {
  leads: LeadWithFunnel[];
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export function useCrmLeads(
  fetchLeads: (options?: UseCrmLeadsOptions) => Promise<LeadWithFunnel[]>,
  options?: UseCrmLeadsOptions
): UseCrmLeadsReturn {
  const [leads, setLeads] = useState<LeadWithFunnel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchLeads(options);
      setLeads(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch leads'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refetch();
  }, [options?.funnelId, options?.stepId, options?.view]);

  return { leads, loading, error, refetch };
}

